import React from 'react';
import QRCode from "react-qr-code";

const QRCodeReader = ({
  qrcode,
  size = 200,
}) => {
  return (
      <div className="col-12 px-0 row mx-0 align-items-center justify-content-center h-100 w-100">
        <QRCode
          value={qrcode}
          size={size}
        />
      </div>
  );
};

export default QRCodeReader;
